import { render, staticRenderFns } from "./PrivacyPolicy.html?vue&type=template&id=f1f28a0c&scoped=true&"
import script from "./PrivacyPolicy.ts?vue&type=script&lang=ts&"
export * from "./PrivacyPolicy.ts?vue&type=script&lang=ts&"
import style0 from "@/scss/components/body/_body.scss?vue&type=style&index=0&id=f1f28a0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1f28a0c",
  null
  
)

export default component.exports